import { useEffect, useState } from "react";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import IconButton from "@mui/material/IconButton";
import Tooltip from "@mui/material/Tooltip";
import { GridColDef, DataGrid } from "@mui/x-data-grid";
import ShowPasswordIcon from "../../images/icons/ShowPasswordIcon.svg";
import { ContentStyle, DataGridListStyle } from "../../Theme";
import { v4 as uuid } from "uuid";
import { loadingPostDatedPresCount } from "../../Redux/Slice/PostDatedPresCountSlice";
import { useDispatch, useSelector } from "react-redux";
import PostDatedPresDetails from "./PostDatedPresDetails";
import { HelpGuideTooltip } from "../../components/HelpGuideTooltip";
import NoRecords from "../../components/NoRecords";
import ErrorOverlay from "../../components/ErrorOverlay";
import { REPORT_BASE_URL } from "../../Apis/Constants";
import { TextOnly } from "../../components/Content";
export default function PostDatedPrescriptions(props: any) {
  const [page, setPage] = useState(0);
  const [pageSize, setPageSize] = useState(50);
  const [showFlow, setShowFlow] = useState(false);
  const [docId, setDocId] = useState<any>();
  const dispatch = useDispatch();

  const columnsPostDatedPrescriptions: GridColDef[] = [
    {
      field: "doctorName",
      headerName: "Details",
      width: 650,
      cellClassName: "w65",
      headerClassName: "w65",
      renderCell: (params: any) => <TextOnly Text={params.value} />,
    },

    {
      field: "prescriptionCount",
      headerName: "Prescriptions",
      width: 150,
      cellClassName: "w35",
      headerClassName: "w35",
      renderCell: (params: any) => <TextOnly Text={params.value} />,
    },
    {
      field: "actions",
      headerName: "Actions",
      width: 100,
      cellClassName: "w30",
      headerClassName: "w30",

      renderCell: ({ row }) => {
        return (
          <>
            <Tooltip title="View">
              <IconButton
                color="primary"
                onClick={() => {
                  setShowFlow(true);
                }}
              >
                <img src={ShowPasswordIcon} alt="View" loading="lazy" />
              </IconButton>
            </Tooltip>
          </>
        );
      },
    },
  ];

  const PostDatedPresCountState = useSelector((state: any) => {
    return { ...state.PostDatedPresCountSlice };
  }); //redux data
  const [rowCountState, setRowCountState] = useState(
    PostDatedPresCountState?.Pagination?.totalItems || 0
  );

  const PostDatedPrescriptionsCount = (nextPage: number) => {
    let pageNumber = {
      pageNumber: nextPage,
      pageSize: pageSize,
    };
    dispatch(loadingPostDatedPresCount(pageNumber));
  };

  useEffect(() => {
    PostDatedPrescriptionsCount(page);
  }, [page]);

  useEffect(() => {
    setRowCountState((prevRowCountState: any) =>
      PostDatedPresCountState?.Pagination?.totalItems !== undefined
        ? PostDatedPresCountState?.Pagination?.totalItems
        : prevRowCountState
    );
  }, [PostDatedPresCountState?.Pagination?.totalItems, setRowCountState]);

  return (
    <>
      {" "}
      <ContentStyle>
        <Grid container item xs={12} spacing={1} alignItems="top">
          <Grid item xs={12} md={6}>
            <Typography
              className="help"
              component="h6"
              color="primary"
              variant="h6"
            >
              Post Dated Prescriptions{" "}
              <HelpGuideTooltip
                content={
                  <>
                    {" "}
                    <Typography component="div" variant="body1">
                      Prescriptions which are prepared to be releases
                      automatically to the pharmacy on a future date. These
                      prescriptions remain valid for 12 months from the date of
                      prescription. All EPCS prescriptions will move to EPCS
                      Queue on scheduled date.
                    </Typography>
                  </>
                }
                pdf={`${REPORT_BASE_URL}drx/PDF/Post%20Dated%20Prescription_User%20Manual%20V1.2.pdf`}
                video={"https://vimeo.com/743045657/41fdac94f4"}
              />
            </Typography>
          </Grid>{" "}
          {showFlow ? (
            <>
              <PostDatedPresDetails docId={docId} setShowFlow={setShowFlow} />
            </>
          ) : (
            <Grid item xs={12}>
              <DataGridListStyle>
                <DataGrid
                  rows={PostDatedPresCountState?.Items ?? []}
                  headerHeight={36}
                  sortingOrder={["desc", "asc"]}
                  columns={columnsPostDatedPrescriptions}
                  autoHeight
                  rowHeight={40}
                  pageSize={pageSize}
                  disableSelectionOnClick
                  onPageSizeChange={(newPageSize) => setPageSize(newPageSize)}
                  paginationMode="server"
                  getRowId={() => uuid()}
                  loading={PostDatedPresCountState.isLoading}
                  components={{
                    NoRowsOverlay: NoRecords,
                    NoResultsOverlay: NoRecords,
                    ErrorOverlay: ErrorOverlay,
                  }}
                  error={PostDatedPresCountState?.error || undefined}
                  rowCount={rowCountState}
                  page={page}
                  rowsPerPageOptions={[pageSize]}
                  onRowClick={({ row }) => {
                    setShowFlow(true);
                    setDocId(row.doctorId);
                  }}
                  onPageChange={(newPage) => {
                    setPage(newPage);
                  }}
                  getRowClassName={({ row }) => {
                    if (!row.onBehalf) {
                      return "PDoctor";
                    }
                    return "";
                  }}
                />
              </DataGridListStyle>{" "}
            </Grid>
          )}
        </Grid>{" "}
      </ContentStyle>
    </>
  );
}
